import { gql } from '@apollo/client';

import { AddAcademyProfessorFormInput } from '../../types/form';
import { AcademyProfessor } from '../../types';
import { academyProfessorFragment } from '../fragments';

export interface AddAcademyProfessorMutationVariables {
  input: AddAcademyProfessorFormInput;
}

export interface AddAcademyProfessorMutationResult {
  academyProfessor: AcademyProfessor;
}

export const addAcademyProfessorMutation = gql`
  mutation AddAcademyProfessorMutation($input: AddAcademyProfessorMutationInput!) {
    academyProfessor(input: $input) @rest(type: "AcademyProfessor", path: "academy/professors", method: "POST") {
      ...AcademyProfessor
    }
  }
  ${academyProfessorFragment}
`;
